// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"dashboard_dashboard__1Xr0a","checkbox":"dashboard_checkbox__UOQjF"};